<template>
  <p class="hero-name">
    <slot name="hero-name" />
  </p>
</template>

<script>
export default {
  name: 'hero-name',
}
</script>

<style lang="scss" scoped>
.hero-name {
  background-image: url(~@images/bg_hero-text.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  font-size: $fs-xlarge;
  text-align: center;
  margin: -90px 0 20px;
  padding: 10px 0;
  position: relative;
}
</style>
